import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from './CoroutineDispatcher.mjs';
import {
  checkParallelism305j5epqg3ju0 as checkParallelism,
  namedOrThis1pi8a62t67wtr as namedOrThis,
} from './internal/LimitedDispatcher.mjs';
import { invokeOnCancellationb68niwbjdmgy as invokeOnCancellation } from './CancellableContinuation.mjs';
import { Delay9umexudtwyie as Delay } from './Delay.mjs';
import { ArrayDeque2dzc9uld4xi7n as ArrayDeque } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayDeque.mjs';
import { removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull } from '../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Runnablezd7bpy5et5p0 as Runnable } from './Runnable.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { coerceIn302bduskdb54x as coerceIn } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { boxApply1qmzdb3dh90hg as boxApply } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CancelHandler3ic7xysezxbm5 as CancelHandler } from './CancellableContinuationImpl.mjs';
import { DisposableHandle1uzxt8frdchxn as DisposableHandle } from './Job.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NodeDispatcherClass;
function NodeDispatcher() {
  if (NodeDispatcherClass === VOID) {
    class $ extends SetTimeoutBasedDispatcher() {
      constructor() {
        NodeDispatcher_instance = null;
        super();
        NodeDispatcher_instance = this;
      }
      p1k() {
        process.nextTick(this.w1k_1.u1k_1);
      }
    }
    initMetadataForObject($, 'NodeDispatcher', VOID, VOID, VOID, [1]);
    NodeDispatcherClass = $;
  }
  return NodeDispatcherClass;
}
var NodeDispatcher_instance;
function NodeDispatcher_getInstance() {
  if (NodeDispatcher_instance === VOID)
    new (NodeDispatcher())();
  return NodeDispatcher_instance;
}
var ScheduledMessageQueueClass;
function ScheduledMessageQueue() {
  if (ScheduledMessageQueueClass === VOID) {
    class $ extends MessageQueue() {
      constructor(dispatcher) {
        super();
        this.t1k_1 = dispatcher;
        var tmp = this;
        tmp.u1k_1 = () => {
          this.a1l();
          return Unit_instance;
        };
      }
      b1l() {
        this.t1k_1.p1k();
      }
      c1l() {
        setTimeout(this.u1k_1, 0);
      }
      d1l(timeout) {
        setTimeout(this.u1k_1, timeout);
      }
    }
    initMetadataForClass($, 'ScheduledMessageQueue');
    ScheduledMessageQueueClass = $;
  }
  return ScheduledMessageQueueClass;
}
function w3cSetTimeout(handler, timeout) {
  return setTimeout(handler, timeout);
}
var WindowMessageQueueClass;
function WindowMessageQueue() {
  if (WindowMessageQueueClass === VOID) {
    class $ extends MessageQueue() {
      constructor(window_0) {
        super();
        this.p1l_1 = window_0;
        this.q1l_1 = 'dispatchCoroutine';
        this.p1l_1.addEventListener('message', (event) => {
          var tmp;
          if (event.source == this.p1l_1 && event.data == this.q1l_1) {
            event.stopPropagation();
            this.a1l();
            tmp = Unit_instance;
          }
          return Unit_instance;
        }, true);
      }
      b1l() {
        var tmp = Promise.resolve(Unit_instance);
        tmp.then((it) => {
          this.a1l();
          return Unit_instance;
        });
      }
      c1l() {
        this.p1l_1.postMessage(this.q1l_1, '*');
      }
    }
    initMetadataForClass($, 'WindowMessageQueue');
    WindowMessageQueueClass = $;
  }
  return WindowMessageQueueClass;
}
function w3cSetTimeout_0(window_0, handler, timeout) {
  return setTimeout_0(window_0, handler, timeout);
}
function w3cClearTimeout(window_0, handle) {
  return window_0.clearTimeout(handle);
}
function w3cClearTimeout_0(handle) {
  return clearTimeout(handle);
}
function setTimeout_0(window_0, handler, timeout) {
  return window_0.setTimeout(handler, timeout);
}
var SetTimeoutDispatcherClass;
function SetTimeoutDispatcher() {
  if (SetTimeoutDispatcherClass === VOID) {
    class $ extends SetTimeoutBasedDispatcher() {
      constructor() {
        SetTimeoutDispatcher_instance = null;
        super();
        SetTimeoutDispatcher_instance = this;
      }
      p1k() {
        this.w1k_1.d1l(0);
      }
    }
    initMetadataForObject($, 'SetTimeoutDispatcher', VOID, VOID, VOID, [1]);
    SetTimeoutDispatcherClass = $;
  }
  return SetTimeoutDispatcherClass;
}
var SetTimeoutDispatcher_instance;
function SetTimeoutDispatcher_getInstance() {
  if (SetTimeoutDispatcher_instance === VOID)
    new (SetTimeoutDispatcher())();
  return SetTimeoutDispatcher_instance;
}
var SetTimeoutBasedDispatcherClass;
function SetTimeoutBasedDispatcher() {
  if (SetTimeoutBasedDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor() {
        super();
        this.w1k_1 = new (ScheduledMessageQueue())(this);
      }
      y12(parallelism, name) {
        checkParallelism(parallelism);
        return namedOrThis(this, name);
      }
      a13(context, block) {
        this.w1k_1.e1l(block);
      }
      p13(timeMillis, block, context) {
        var handle = w3cSetTimeout(() => {
          block.w11();
          return Unit_instance;
        }, delayToInt(timeMillis));
        return new (ClearTimeout())(handle);
      }
      o13(timeMillis, continuation) {
        var handle = w3cSetTimeout(() => {
          // Inline function 'kotlin.with' call
          continuation.kz(this, Unit_instance);
          return Unit_instance;
        }, delayToInt(timeMillis));
        invokeOnCancellation(continuation, new (ClearTimeout())(handle));
      }
    }
    initMetadataForClass($, 'SetTimeoutBasedDispatcher', VOID, VOID, [Delay()], [1]);
    SetTimeoutBasedDispatcherClass = $;
  }
  return SetTimeoutBasedDispatcherClass;
}
var MessageQueueClass;
function MessageQueue() {
  if (MessageQueueClass === VOID) {
    class $ {
      constructor() {
        this.x1k_1 = ArrayDeque().nj();
        this.y1k_1 = 16;
        this.z1k_1 = false;
      }
      e1l(element) {
        this.f1l(element);
        if (!this.z1k_1) {
          this.z1k_1 = true;
          this.b1l();
        }
      }
      a1l() {
        try {
          // Inline function 'kotlin.repeat' call
          var times = this.y1k_1;
          var inductionVariable = 0;
          if (inductionVariable < times)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0_elvis_lhs = removeFirstOrNull(this);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                return Unit_instance;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var element = tmp;
              element.w11();
            }
             while (inductionVariable < times);
        }finally {
          if (this.n1()) {
            this.z1k_1 = false;
          } else {
            this.c1l();
          }
        }
      }
      f1l(element) {
        return this.x1k_1.i2(element);
      }
      i2(element) {
        return this.f1l((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      g1l(index, element) {
        this.x1k_1.b5(index, element);
      }
      b5(index, element) {
        return this.g1l(index, (!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      h1l(elements) {
        return this.x1k_1.u2(elements);
      }
      u2(elements) {
        return this.h1l(elements);
      }
      a5() {
        this.x1k_1.a5();
      }
      i1l(index, element) {
        return this.x1k_1.j3(index, element);
      }
      j3(index, element) {
        return this.i1l(index, (!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      c5(index) {
        return this.x1k_1.c5(index);
      }
      v2(index) {
        return this.x1k_1.v2(index);
      }
      b3(fromIndex, toIndex) {
        return this.x1k_1.b3(fromIndex, toIndex);
      }
      n1() {
        return this.x1k_1.n1();
      }
      j1l(element) {
        return this.x1k_1.t2(element);
      }
      t2(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return false;
        return this.j1l((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      p1() {
        return this.x1k_1.p1();
      }
      k1l(elements) {
        return this.x1k_1.q4(elements);
      }
      q4(elements) {
        return this.k1l(elements);
      }
      r2(index) {
        return this.x1k_1.r2(index);
      }
      l1l(element) {
        return this.x1k_1.r4(element);
      }
      r4(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return -1;
        return this.l1l((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      q2() {
        return this.x1k_1.kj_1;
      }
    }
    initMetadataForClass($, 'MessageQueue', VOID, VOID, [KtMutableList()]);
    MessageQueueClass = $;
  }
  return MessageQueueClass;
}
var WindowClearTimeoutClass;
function WindowClearTimeout() {
  if (WindowClearTimeoutClass === VOID) {
    class $ extends ClearTimeout() {
      constructor($outer, handle, $box) {
        if ($box === VOID)
          $box = {};
        $box.k1m_1 = $outer;
        super(handle, $box);
      }
      uz() {
        w3cClearTimeout(this.k1m_1.m1m_1, this.o1m_1);
      }
    }
    initMetadataForClass($, 'WindowClearTimeout');
    WindowClearTimeoutClass = $;
  }
  return WindowClearTimeoutClass;
}
function Runnable$run$ref(p0) {
  var l = () => {
    p0.w11();
    return Unit_instance;
  };
  l.callableName = 'run';
  return l;
}
var WindowDispatcherClass;
function WindowDispatcher() {
  if (WindowDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor(window_0) {
        super();
        this.m1m_1 = window_0;
        this.n1m_1 = new (WindowMessageQueue())(this.m1m_1);
      }
      a13(context, block) {
        return this.n1m_1.e1l(block);
      }
      o13(timeMillis, continuation) {
        var handle = w3cSetTimeout_0(this.m1m_1, () => {
          // Inline function 'kotlin.with' call
          continuation.kz(this, Unit_instance);
          return Unit_instance;
        }, delayToInt(timeMillis));
        invokeOnCancellation(continuation, new (WindowClearTimeout())(this, handle));
      }
      p13(timeMillis, block, context) {
        var handle = w3cSetTimeout_0(this.m1m_1, Runnable$run$ref(block), delayToInt(timeMillis));
        return new (WindowClearTimeout())(this, handle);
      }
    }
    initMetadataForClass($, 'WindowDispatcher', VOID, VOID, [Delay()], [1]);
    WindowDispatcherClass = $;
  }
  return WindowDispatcherClass;
}
function delayToInt(timeMillis) {
  return convertToInt(coerceIn(timeMillis, 0n, 2147483647n));
}
var ClearTimeoutClass;
function ClearTimeout() {
  if (ClearTimeoutClass === VOID) {
    class $ {
      constructor(handle, $box) {
        boxApply(this, $box);
        this.o1m_1 = handle;
      }
      uz() {
        w3cClearTimeout_0(this.o1m_1);
      }
      tz(cause) {
        this.uz();
      }
      toString() {
        return 'ClearTimeout[' + this.o1m_1 + ']';
      }
    }
    initMetadataForClass($, 'ClearTimeout', VOID, VOID, [CancelHandler(), DisposableHandle()]);
    ClearTimeoutClass = $;
  }
  return ClearTimeoutClass;
}
//region block: exports
export {
  NodeDispatcher_getInstance as NodeDispatcher_getInstance2q3lgzi7kwduh,
  SetTimeoutDispatcher_getInstance as SetTimeoutDispatcher_getInstancemoakmytvf1nl,
  WindowDispatcher as WindowDispatcheram3q94j2gxvn,
};
//endregion

//# sourceMappingURL=JSDispatcher.mjs.map
